import UserEdit from './UserEdit'
import UserList from './UserList'

const users = {
  list: UserList,
  edit: UserEdit,
}

export default users
